/**
 * @deprecated Use ../privateDocuments
 */
export * from '../privateDocuments';
